::ng-deep app-show-country-calculators-dialog{width:100%}
/*# sourceMappingURL=show-country-calculators-dialog.component-D2W3QQYW.css.map */
